import React, { useState, useEffect } from 'react';
import {get} from 'lodash';
import { _ } from 'core-js';

export default function () {
    const [products, setProducts] = useState({})
    // load json from url
    useEffect(() => {
        fetch('https://afoodapart.com/api/menu/taronglendale')
            .then(response => response.json())
            .then(data => setProducts(data))
            .catch(error => console.error('Error fetching products:', error));
    }, []);


    const subMenus = get(products, 'menu.subMenus', [])
    // console.log(productsList)
    return(
        <div className="featured-products">
            {subMenus.map(({id, name, products}) => {
                return(
                    null
                )
            })}
        </div>
    )
}